interface ActiveVideo {
    id: symbol;
    stop: () => void;
}

let active: ActiveVideo | null = null;

export function claimActiveVideo(id: symbol, stop: () => void): void {
    if (active && active.id !== id) {
        const previous = active;
        active = null;
        previous.stop();
    }
    active = { id, stop };
}

export function releaseActiveVideo(id: symbol): void {
    if (active?.id === id) {
        active = null;
    }
}
